import React from 'react';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import Divider from '@mui/material/Divider';
import PropTypes from 'prop-types';
import CompactMetricItem from './CompactMetricItem';

/**
 * GroupCard - A card that groups related metrics together
 * Used for organizing multiple metrics into logical sections
 */
const GroupCard = ({ title, metrics, className }) => (
  <Paper variant="outlined" sx={{ mb: 2 }} className={className}>
    <Box sx={{ p: 1.5, bgcolor: 'background.default' }}>
      <Typography variant="subtitle2" fontWeight="medium">{title}</Typography>
    </Box>
    <Divider />
    <Stack spacing={0} divider={<Divider />}>
      {metrics.map((metric, index) => (
        <CompactMetricItem
          key={`${metric.title}-${index}`}
          title={metric.title}
          value={metric.value}
          currency={metric.currency}
          isHighlighted={metric.isHighlighted}
        />
      ))}
    </Stack>
  </Paper>
);

GroupCard.propTypes = {
  title: PropTypes.string.isRequired,
  metrics: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string.isRequired,
      value: PropTypes.number.isRequired,
      currency: PropTypes.string,
      isHighlighted: PropTypes.bool
    })
  ).isRequired,
  className: PropTypes.string
};

export default GroupCard;